import React from 'react';
import styled, {useTheme} from 'styled-components/native';
import SkeletonPlaceholder from '../../skeletonPlaceholder';
import Animated, {FadeInDown, FadeOut} from 'react-native-reanimated';
import {ViewStyle} from 'react-native';

const Container = styled.View`
  width: 100%;
  height: 100%;
  margin-top: 2%;
`;

const BubbleContainer = styled(Animated.View)<{isSent?: boolean}>`
  flex-direction: row;
  width: 100%;
  align-items: center;
  justify-content: ${({isSent}) => (isSent ? 'flex-end' : 'flex-start')};
  margin-top: ${({theme}) => theme.text.s4}px;
  margin-left: ${({isSent}) => (!isSent ? 2 : 0)}%;
`;

const Bubble = styled.View<{isSent?: boolean}>`
  flex: 1;
  margin-horizontal: 2%;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: ${({isSent}) => (isSent ? 'flex-end' : 'flex-start')};
`;

const ChatSkeleton = ({style}: {style: ViewStyle}) => {
  const theme = useTheme();
  const data = [
    {
      isSent: true,
      width: '34%',
      height: theme.text.s1 * 4,
    },
    {
      isSent: false,
      width: '90%',
      height: theme.text.s1 * 10,
    },
    {
      isSent: true,
      width: '70%',
      height: theme.text.s1 * 3,
    },
    {
      isSent: false,
      width: '90%',
      height: theme.text.s1 * 10,
    },
  ];
  return (
    <Container style={style}>
      {data.map((item, idx) => (
        <BubbleContainer
          entering={FadeInDown}
          exiting={FadeOut}
          key={idx}
          isSent={item.isSent}>
          <Bubble isSent={item.isSent}>
            <SkeletonPlaceholder
              width={item.width}
              height={item.height}
              borderRadius={0}
              borderTopLeft={item.isSent ? 20 : 5}
              borderTopRight={item.isSent ? 5 : 20}
              borderBottomRight={20}
              borderBottomLeft={20}
            />
          </Bubble>
        </BubbleContainer>
      ))}
    </Container>
  );
};

export default ChatSkeleton;
